import React, { useEffect, useMemo, useState } from 'react';
import moment from 'moment-timezone';
import { useTranslation } from 'react-i18next';

const PROMO_TARGET_DATES = {
  Omega3_Product_Promo_Message: '2026-09-27 23:59:59',
  Omega3_Addon_Promo_Message: '2026-04-20 00:00:00',
};

function getTimeLeft(targetMoment) {
  const diff = Math.max(targetMoment.valueOf() - Date.now(), 0);
  const totalSeconds = Math.floor(diff / 1000);
  const days = Math.floor(totalSeconds / 86400);
  const hours = Math.floor((totalSeconds % 86400) / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  return { days, hours, minutes, seconds, expired: diff <= 0 };
}

function pad(value) {
  return String(value).padStart(2, '0');
}

const Omega3PromoBar = ({ messageKey }) => {
  const { t } = useTranslation();
  const [targetDate] = useState(() =>
    moment.tz(PROMO_TARGET_DATES[messageKey] || PROMO_TARGET_DATES.Omega3_Product_Promo_Message, 'Europe/Paris'),
  );
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(targetDate));

  useEffect(() => {
    if (timeLeft.expired) return undefined;

    const interval = window.setInterval(() => {
      setTimeLeft(getTimeLeft(targetDate));
    }, 1000);

    return () => window.clearInterval(interval);
  }, [targetDate, timeLeft.expired]);

  const countdownLabel = useMemo(
    () => `${timeLeft.days}d ${pad(timeLeft.hours)}h ${pad(timeLeft.minutes)}m ${pad(timeLeft.seconds)}s`,
    [timeLeft],
  );

  // Once the offer ends the bar disappears entirely, leaving the page as it was before the promo.
  if (timeLeft.expired) {
    return null;
  }

  return (
    <div className="t-bg-navy t-px-4 t-py-2 t-text-center t-text-[12px] md:t-text-[13px] t-font-semibold t-text-white">
      <span className="t-inline-flex t-flex-wrap t-items-center t-justify-center t-gap-x-2 t-gap-y-1">
        <span>{t(messageKey)}</span>
        <span className="t-text-butter">{countdownLabel}</span>
      </span>
    </div>
  );
};

export default Omega3PromoBar;
